import { ApplicationState } from '../types';

export const getRothConversionExecuteState = ({
  executeRothConversionTransaction,
}: ApplicationState) => executeRothConversionTransaction;

export const getRothConversionTradeDates = ({
  executeRothConversionTransaction,
}: ApplicationState) => {
  return (
    executeRothConversionTransaction.rothConversionTradeDates
      ?.estimatedTradeDate || {}
  );
};
